/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: User api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as usersService from '../../services/userList';
import moment from 'moment';

const userListModel = {
  user: {},
  setUser: action((state, payload) => {
    state.user = payload;
  }),
  getUser: thunk(async (actions, payload) => {
    await usersService
      .getUser(payload)
      .then(function (response) {
        actions.setUser(response.data.data);
      })
      .catch(function (error) {

        actions.setUser({});
      });
  }),
  userList: [],
  productRoles: [],
  setUserList: action((state, payload) => {
    state.userList = payload;
  }),
  setProductRoles: action((state, payload) => {
    state.productRoles = payload;
  }),
  userListLoader: false,
  setUserListLoader: action((state, payload) => {
    state.userListLoader = payload;
  }),
  getUserList: thunk(async (actions, payload) => {
    await usersService.getUserList(payload)
    .then(function (response) {
      actions.setUserListLoader(false);
      actions.setUserList(response.data.data.users);
    })
    .catch(function (error) {
      actions.setUserListLoader(false);
      actions.setUserList([]);
    });
  }),
  getUserListForReport: thunk(async (actions, payload) => {
    await usersService.getUserListForReport(payload)
    .then(function (response) {
      actions.setUserListLoader(false);
      actions.setUserList(response.data.data.users);
    })
    .catch(function (error) {
      actions.setUserListLoader(false);
      actions.setUserList([]);
    });
  }),
  addUser: thunk(async (actions, payload, helpers) => {
    //return await usersService.addUser(payload);
    const response = await usersService.addUser(payload);
    let userList = helpers.getState().userList;
    response.data.data.create_date = moment()
    if (payload.permissions) {
      response.data.data.permissions = payload.permissions
    }    
   // if (payload.user_policies) {
      response.data.data.user_policies = payload.user_policies
   // }  
    actions.setUserList([response.data.data, ...userList]);
  }),
  updateUser: thunk(async (actions, payload, helpers) => {
    await usersService.updateUser(payload);
    let userInfoList = helpers.getState().userList;
    for (let i = 0; i < userInfoList.length; i++) {
      if (userInfoList[i].PK === payload.PK) {
        userInfoList[i] = payload;
        break;
      }
    }
    actions.setUserList([...userInfoList]);
  }),
  updateUserStatus: thunk(async (actions, payload) => {
    return await usersService.updateUserStatus(payload);
  }),
  getProductRoles: thunk(async(actions, payload) => {
    await usersService
      .getProductRoles(payload)
      .then(function (response) {
        actions.setProductRoles(response.data.data.productRoles);
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setProductRoles([]);
      });
  }),
  updateUserRole: thunk(async(actions, payload, helpers)=>{
    const res = await usersService.updateUserRole(payload.current_user);
    let userInfoList = helpers.getState().userList;
    for (let i = 0; i < userInfoList.length; i++) {
      if (userInfoList[i].PK === res.data.data.PK) {
        userInfoList[i].root_user = res.data.data.root_user;
      }else if(userInfoList[i].PK === payload.login_user){
        userInfoList[i].root_user = 0;
      }
    }
    actions.setUserList([...userInfoList]);
    return res;
  })
};


export default userListModel;
